var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCopy = function SvgCopy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0C6.9 0 6 .9 6 2v12c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V4.8c0-.5-.2-1-.6-1.4L14.6.6c-.4-.4-.9-.6-1.4-.6H8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 6c0-1.1.9-2 2-2v12c0 1.1.9 2 2 2h8c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6z"
  })));
};
export default SvgCopy;